// import React, { useEffect, useRef, useState } from "react";
// import {
//   Button,
//   Select,
//   MenuItem,
//   InputLabel,
//   FormControl,
//   TextField,
//   CircularProgress,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Tooltip,
//   IconButton,
//   Input,
// } from "@material-ui/core";
// import {
//   Delete as DeleteIcon,
//   CloudUpload as CloudUploadIcon,
//   GetApp as GetAppIcon,
// } from "@material-ui/icons";
// import { FilePicker, Text } from "evergreen-ui";
// import { styled } from "@mui/material/styles";
// import { makeStyles } from "@material-ui/core/styles";
// import "./attachment.scss";
// import axiosInstance from "../../../../../httpInterceptor";
// import { useParams } from "react-router-dom";
// import { Document, Page, pdfjs } from "react-pdf";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import Modal from "react-modal";
// import { toast } from "react-toastify";
// import { CiFileOn } from "react-icons/ci";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTrash, faEdit, faDownload } from "@fortawesome/free-solid-svg-icons";
// import RingLoader from "react-spinners/RingLoader";
// import HashLoader from "react";
// import ScaleLoader from "react-spinners/ScaleLoader";
// import { RiDeleteBin6Line, RiDownload2Line } from "react-icons/ri";
// import {
//   FaFilePdf,
//   FaFileWord,
//   FaFileAlt,
//   FaFile,
//   FaFilePowerpoint,
// } from "react-icons/fa";
// import { GrDocumentUpload } from "react-icons/gr";
// import axios from "axios";
// import Menu from "@mui/material/Menu";
// import { ReactMultiEmail, isEmail } from "react-multi-email";
// import "react-multi-email/dist/style.css";
// import { MdEmail } from "react-icons/md";
// import CloseIcon from "@material-ui/icons/Close";
// import SaveIcon from "@material-ui/icons/Save";
// import {
//   AssessmentData,
//   ProjectDataType,
//   Qnadetails,
// } from "../../../../../models/interfaces/interfaces";

// import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   SelectChangeEvent,
//   TooltipProps,
//   Typography,
//   useMediaQuery,
// } from "@mui/material";
// import { saveAs } from "file-saver";
// pdfjs.GlobalWorkerOptions.workerSrc = "/js/pdf.worker.min copy.mjs";
// interface FileUploadProps {
//   projectid?: string;
//   setName?: string;
//   emails: string[];
// }
// interface UploadedFile {
//   _id: string;
//   category: string;
//   url: string[];
//   type: string;
// }
// interface FileRecord {
//   projectid: string;
//   set_name: string;
//   files: UploadedFile[];
// }

// const customeToolpit = makeStyles({
//   tooltip: {
//     backgroundColor: "white",
//     color: "blue",
//   },
// });

// const useStyles = makeStyles((theme: any) => ({
//   formControl: {
//     margin: theme.spacing(1),
//     minWidth: 200,
//   },
//   uploadButton: {
//     margin: theme.spacing(1),
//   },
//   table: {
//     marginTop: theme.spacing(2),
//   },
//   errorMessage: {
//     color: "red",
//   },
//   loadingMessage: {
//     color: "orange",
//     textAlign: "center",
//   },
// }));

// const FileUpload: React.FC<FileUploadProps> = ({
//   projectid,
//   setName,
//   emails,
// }) => {
//   const [files, setFiles] = useState<File[]>([]);
//   const [filesList, setFilesList] = useState<UploadedFile[]>([]);
//   const [category, setCategory] = useState("");
//   const [customCategory, setCustomCategory] = useState("");
//   const [showCustomCategoryInput, setShowCustomCategoryInput] = useState(false);
//   const [cloudFrontUrls, setCloudFrontUrls] = useState<string[]>([]);
//   const [error, setError] = useState("");
//   const [previewUrls, setPreviewUrls] = useState<string[]>([]);
//   const [emailAdresses, setEmailAddress] = useState("");
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [showFullFileName, setShowFullFileName] = useState<{
//     [key: number]: boolean;
//   }>({});
//   const [loading, setLoading] = useState(false);
//   const [itemToDelete, setItemToDelete] = useState<string | null>(null);

//   const [open, setOpen] = useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [isChecked, setIsChecked] = useState(false);
//   const [mails, setEmails] = useState<string[]>([]);
//   const [showEmailField, setShowEmailField] = useState(false);
//   const [isSubmitButton, setIsSubmitButton] = useState(false);
//   const { proj_id, set_name } = useParams<{
//     proj_id: string;
//     set_name: string;
//   }>();
//   const [dialogPosition, setDialogPosition] = useState({ top: 0, left: 0 });
//   const [assessmentData, setAssessmentData] = useState<AssessmentData>({
//     projectid: proj_id || "",
//     set_name: set_name || "",
//     emailIds: JSON.parse(localStorage.getItem("emailIds") || "[]"),
//     assessmentdetails: [
//       {
//         assessmentdate: `${new Date().toISOString().split("T")[0]}`,
//         projectstatus: "",
//         reasonforchange: "",
//         qnadetails: [],
//         created_by: `${sessionStorage.getItem("PBT_FIRSTNAME") || ""} ${sessionStorage.getItem("PBT_LASTNAME") || ""
//           }`,
//         modified_by: "",
//       },
//     ],
//   });

//   const isSmallScreen = useMediaQuery('(max-width:1200px)');

//   useEffect(() => {
//     fetchFiles();
//   }, []);

//   useEffect(() => {
//     document.body.setAttribute("data-loading", loading ? "true" : "false");

//     return () => {
//       document.body.removeAttribute("data-loading");
//     };
//   }, [loading]);

//   const fetchFiles = async () => {
//     try {
//       const response = await axiosInstance.get(
//         `${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/files/${projectid}/${setName}`
//       );
//       const fileRecords: FileRecord[] = response.data || [];
//       const allFiles = fileRecords.flatMap((record) => record.files);
//       setFilesList(allFiles);
//       console.log(allFiles);
//     } catch (error) {
//       console.error("Error fetching files:", error);
//     }
//   };
//   console.log(filesList[0]);

//   const allowedFileTypes = [
//     "application/pdf",
//     "text/plain",
//     "application/msword",
//     "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//     "application/vnd.openxmlformats-officedocument.presentationml.presentation",
//   ];

//   // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//   //   const selectedFiles = Array.from(e.target.files || []);
//   //   const validFiles = selectedFiles.filter((file: File) =>
//   //     allowedFileTypes.includes(file.type)
//   //   );
//   //   if (validFiles.length !== selectedFiles.length) {
//   //     setError(
//   //       "Some files have invalid types. Only PDF, TXT, DOC, DOCX,PPTX files are allowed."
//   //     );
//   //   } else {
//   //     setError("");
//   //   }
//   //   setFiles(validFiles as File[]);
//   // };

//   const handleFileChange = (fileList: FileList) => {
//     const selectedFiles = Array.from(fileList);
//     const validFiles = selectedFiles.filter((file) =>
//       allowedFileTypes.includes(file.type)
//     );

//     if (validFiles.length !== selectedFiles.length) {
//       setError(
//         "Some files have invalid types. Only PDF, TXT, DOC, DOCX, PPTX files are allowed."
//       );
//     } else {
//       setError("");
//     }

//     setFiles(validFiles);
//   };

//   const handleCheckboxChange = () => {
//     setIsChecked(!isChecked);
//   };

//   const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setEmailAddress(e.target.value);
//   };

//   const handleCategoryChange = (event: any) => {
//     const selected = event.target.value;

//     if (selected === "Others") {
//       setShowCustomCategoryInput(true);
//       setCategory(""); // Clear category until custom input is submitted
//     } else {
//       setShowCustomCategoryInput(false);
//       setCategory(selected);
//     }
//   };

//   const handleCustomCategoryChange = (
//     e: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     setCustomCategory(e.target.value);
//   };

//   const handleCustomCategorySubmit = (
//     e: React.KeyboardEvent<HTMLInputElement>
//   ) => {
//     setCategory(customCategory);
//   };
//   const handleFileUpload = async () => {
//     let finalCategory = category;

//     if (showCustomCategoryInput && customCategory.trim()) {
//       finalCategory = customCategory.trim();
//     }

//     if (files.length === 0) {
//       setError("No files selected.");
//       return;
//     }
//     if (!projectid) {
//       setError("Project ID is required.");
//       return;
//     }
//     if (!setName) {
//       setError("Set name is required.");
//       return;
//     }
//     if (!finalCategory) {
//       setError("Category is required.");
//       return;
//     }

//     // Use finalCategory instead of category in formData

//     console.log(category);
//     let uploadedUrls: string[] = [];
//     const previewUrls: string[] = [];
//     setLoading(true);
//     try {
//       for (const file of files) {
//         const presignRes = await axiosInstance.post(`${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/generate-presigned-url`, {
//           fileName: file.name,
//           fileType: file.type,
//         });
//         const uploadUrl = presignRes.data.url;
//         console.log("Presigned URL:", uploadUrl);
//         const cloudFrontUrl = uploadUrl.replace(
//           /^https:\/\/[^/]+\.s3\.amazonaws\.com\//,
//           `${process.env.REACT_APP_CLOUDFRONT_BASE_URL}/`
//         );
//         console.log("CloudFront URL:", cloudFrontUrl);

//         await fetch(uploadUrl, {
//           method: "PUT",
//           headers: {
//             "Content-Type": file.type,
//           },
//           body: file,
//         });

//         const processRes = await axiosInstance.post(`${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/process-uploaded-file`, {
//           fileName: file.name,
//           projectid,
//           set_name: setName,
//           category: finalCategory,
//           mimetype: file.type,
//         });
//         console.log("Process response:", processRes.data);
//         toast.success("File successfully uploaded and processed");
//         uploadedUrls.push(cloudFrontUrl);
//         previewUrls.push(URL.createObjectURL(file));
//       }
//       setCloudFrontUrls(uploadedUrls);
//       setPreviewUrls(previewUrls);
//       setDropdownOpen(false);
//       fetchFiles();
//     } catch (error: any) {
//       console.error("Error uploading file:", error);

//       if (error.response && error.response.data) {
//         console.log(error.response.data);
//         setError(error.response.data);
//         console.log(error);
//       } else {
//         setError("Error uploading file.");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };
//   //       const response = await axiosInstance.post(
//   //         `${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/upload/${projectid}/${setName}`,
//   //         formData,
//   //         {
//   //           headers: {
//   //             "Content-Type": "multipart/form-data",
//   //           },
//   //         }
//   //       );
//   //       if (response.data) {
//   //         toast.success("File successfully uploaded");
//   //         // window.location.reload();
//   //         console.log(formData);
//   //         console.log(response);
//   //         uploadedUrls.push(response.data.cloudFrontUrls);
//   //         previewUrls.push(URL.createObjectURL(file));
//   //         console.log(uploadedUrls);
//   //       }
//   //     }
//   //     if (withEmail) {
//   //       const emailPayload = {
//   //         projectid,
//   //         setName,
//   //         toEmail: emails,
//   //         emailType: "file",
//   //         files: uploadedUrls,
//   //       };
//   //       const res = await axiosInstance.post(
//   //         `${process.env.REACT_APP_EMAIL_SERVICE_BASE_URL}/email`,
//   //         emailPayload,
//   //         {
//   //           headers: {
//   //             "Content-Type": "application/json",
//   //           },
//   //         }
//   //       );
//   //       if (res.data) {
//   //         toast.success(
//   //           "Email sent successfully. Thank you, check your email."
//   //         );
//   //       }
//   //     }
//   //     window.location.reload();
//   //     setLoading(false);
//   //   } catch (error: any) {
//   //     console.error("Error uploading file:", error);

//   //     if (error.response && error.response.data) {
//   //       console.log(error.response.data);
//   //       setError(error.response.data);
//   //       console.log(error);
//   //     } else {
//   //       setError("Error uploading file.");
//   //     }
//   //   }

//   //   setCloudFrontUrls(uploadedUrls);
//   //   setPreviewUrls(previewUrls);
//   //   setDropdownOpen(false);
//   //   fetchFiles();
//   //   // setError("");
//   //   console.log("Files uploaded successfully:", uploadedUrls);
//   //   console.log(setPreviewUrls);
//   // };

//   const handleButtonClick = async () => {
//     setShowEmailField(true);
//   };
//   const handleDelete = async (_id: string) => {
//     await axiosInstance.delete(
//       `${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/delete/${_id}`
//     );
//     toast.success("File deleted successfully");
//     fetchFiles();
//   };

//   const handleDownload = async (_id: string) => {
//     console.log("Downloading file with id:", _id);
//     try{
//     const response = await axiosInstance.get(
//       `${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/files/download/${_id}`
//     ); 
//     const downloadUrl = response.data.downloadUrl; // Assuming the URL is returned in the response data
//     console.log("Download URL:", downloadUrl);
//     // const link = document.createElement("a");
//     // link.href= downloadUrl;
//     // link.download = getFileName(downloadUrl) || "file.pdf"; // Default filename if not provided
//     // document.body.appendChild(link);
//     // link.click();

// // Fetch the file as a blob
//     const fileResponse = await axios.get(downloadUrl, {
//       responseType: 'blob',
//     });

//     // // Extract filename from URL or use default
//     // const fileName = getFileName(downloadUrl) || "downloaded_file.pdf";

//     // // Save the file locally
//     // saveAs(fileResponse.data, fileName);

//     const fileName = decodeURIComponent(downloadUrl.split("/").pop()?.split("?")[0] || "downloaded_file");
//     const fileExtension = fileName.split(".").pop()?.toLowerCase();


//     // // document.body.removeChild(link);
//     const blobUrl = window.URL.createObjectURL(new Blob([fileResponse.data]));

//    // You can customize the extension here
//     const link = document.createElement('a');
//     link.href = blobUrl;
//     link.setAttribute('download', fileName);
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//   } catch (error) {
//     console.error("Error downloading file:", error);
//     toast.error("Failed to download file");
//   }
//     // // Extract filename from the response headers
//     // const contentDisposition = response.headers["content-disposition"];
//     // let filename = "file.pdf"; // Default filename
//     // if (contentDisposition) {
//     //   const filenameMatch = contentDisposition.match(/filename="(.+)"/);
//     //   if (filenameMatch.length === 2) {
//     //     filename = filenameMatch[1];
//     //   }
//     // }

//     // const url = window.URL.createObjectURL(new Blob([response.data]));
//     // const link = document.createElement("a");
//     // link.href = url;
//     // link.setAttribute("download", filename);
//     // document.body.appendChild(link);
//     // link.click();
//     // document.body.removeChild(link);
//   };

//   const getFileName = (url: string) => {
//     return url.split("/").pop();
//   };
//   const toggleFullFileName = (index: number) => {
//     setShowFullFileName((prevState) => ({
//       [index]: !prevState[index],
//     }));
//   };

//   const getFileIcon = (fileType: any): JSX.Element => {
//     switch (fileType) {
//       case "pdf":
//         return <FaFilePdf style={{ color: "red" }} />;
//       case "docx":
//       case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
//         return <FaFileWord style={{ color: "blue" }} />;
//       case "pptx":
//       case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
//         return <FaFilePowerpoint style={{ color: "orange" }} />;
//       case "txt":
//         return <FaFileAlt style={{ color: "green" }} />;
//       default:
//         return <FaFile style={{ color: "gray" }} />;
//     }
//   };

//   const getFileType = (url: string): string => {
//     const fileName = url.split("/").pop();
//     if (fileName) {
//       const fileType = fileName
//         .split(".")
//         .pop()
//         ?.replace(/[^a-zA-Z].*$/, "");
//       return fileType || "";
//     }
//     return "";
//   };
//   const CustomTextField = styled(TextField)({
//     "& .MuiInput-underline:before": {
//       borderBottomColor: "initial",
//     },
//     "& .MuiInput-underline:hover:before": {
//       borderBottomColor: " #074173",
//     },
//     "& .MuiInput-underline:after": {
//       borderBottomColor: " #074173",
//     },
//   });
//   const useStyles = makeStyles((theme) => ({
//     modalBox: {
//       position: "absolute",
//       top: "50%",
//       left: "50%",
//       transform: "translate(-50%, -50%)",
//       background: "#ddd",

//       boxShadow: theme.shadows[5],
//       padding: theme.spacing(2, 4, 3),
//       outline: "none",
//       height: "40vh",
//       borderRadius: "4px",
//     },
//     emailField: {
//       display: "flex",
//       flexDirection: "column",
//       gap: theme.spacing(2),
//     },
//     buttonEmail: {
//       display: "flex",
//       justifyContent: "space-between",
//     },
//     emailTag: {
//       display: "flex",
//       alignItems: "center",
//       gap: theme.spacing(1),
//     },
//     label: {
//       color: " #0d5eff",
//       background: "white",
//       fontSize: "0.7rem",
//       border: "0.3px solid #ddd",
//     },
//   }));

//   const handleDeleteClick = (
//     itemId: any,
//     event: React.MouseEvent<HTMLButtonElement>
//   ) => {
//     const rect = event.currentTarget.getBoundingClientRect();
//     setDialogPosition({
//       top: rect.top + window.scrollY,
//       left: rect.left + window.scrollX,
//     });

//     setItemToDelete(itemId);
//     setOpen(true);
//   };

//   const handleDel = () => {
//     if (itemToDelete !== null) {
//       handleDelete(itemToDelete);
//       setOpen(false);
//     }
//   };

//   const handleConfirmDelete = (_id: string) => {
//     handleDelete(_id);
//     setOpen(false);
//   };

//   const close = () => {
//     setOpen(false);
//   };

//   const handleClick = (event: any) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const handleSaveEmails = async () => {
//     const projectKey = `${assessmentData.projectid}_${assessmentData.set_name}`;
//     const storedData = JSON.parse(localStorage.getItem("emailData") || "{}");
//     const existingEmailIds = storedData[projectKey] || [];
//     // Merge and deduplicate email IDs
//     const emailSet = new Set([...existingEmailIds, ...emails]);
//     const updatedEmailIds = Array.from(emailSet);
//     // Store the updated email IDs in localStorage
//     storedData[projectKey] = updatedEmailIds;
//     localStorage.setItem("emailData", JSON.stringify(storedData));
//     alert("Email IDs saved successfully!");
//     setEmails(updatedEmailIds);
//     setShowEmailField(false);
//     // Send the combined email IDs to the backend
//     if (assessmentData.projectid && assessmentData.set_name) {
//       try {
//         const response = await axiosInstance.post(
//           `${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/create-projectassesment`,
//           {
//             projectid: assessmentData.projectid,
//             set_name: assessmentData.set_name,
//             emailIds: updatedEmailIds,
//           }
//         );
//         console.log("Response from API:", response);
//         if (response.data) {
//           toast.success("Email IDs updated successfully");
//         }
//       } catch (error) {
//         console.error("Error updating email IDs:", error);
//         toast.error("Failed to update email IDs");
//       }
//     }
//   };
//   const handleCloseModal = () => {
//     setShowEmailField(false);
//   };

//   const css = useStyles();

//   return (
//     <div style={{ padding: "24px" }}>
//       <div
//         style={{
//           backgroundColor: "rgb(165, 164, 164)",
//           padding: "1.3rem",
//           borderRadius: "3px",
//           translate: "-25px -25px",
//           width: "101%",
//         }}
//       ></div>
//       <Typography style={{ color: "#888888", fontFamily: "System-ui" }}>
//         Only documents in TXT, PDF, PPTX, or DOCX formats are permitted
//       </Typography>
//       <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//         <FormControl style={{ margin: "8px", minWidth: "200px" }}>
//           <InputLabel style={{ translate: "-9px" }}>Document Type</InputLabel>
//           <Select
//             style={{ translate: "-9px 4px" }}
//             onChange={(event) => handleCategoryChange(event)}
//             inputProps={{
//               classes: {
//                 underline: {
//                   "&:before": {
//                     borderBottomColor: "#074173",
//                   },
//                   "&:hover:not(.Mui-disabled):before": {
//                     borderBottomColor: "#074173", // Color on hover
//                   },
//                   "&:after": {
//                     borderBottomColor: "#074173", // Default color when focused
//                   },
//                 },
//               },
//             }}
//           >
//             <MenuItem value="">Category Type</MenuItem>
//             <MenuItem value="Proposal">Proposal</MenuItem>
//             <MenuItem value="SoW - Development1">SoW - Development1</MenuItem>
//             <MenuItem value="SoW - Development2">SoW - Development2</MenuItem>
//             <MenuItem value="SoW - Support">SoW - Support</MenuItem>
//             <MenuItem value="SoW Details Extraction">
//               SoW Details Extraction
//             </MenuItem>
//             <MenuItem value="Others">Others</MenuItem>
//           </Select>
//         </FormControl>

//         {showCustomCategoryInput && (
//           <TextField
//             label="Category Type"
//             variant="outlined"
//             size="small"
//             value={customCategory}
//             onChange={(e) => setCustomCategory(e.target.value)}
//             onKeyDown={(e) => {
//               if (e.key === "Enter" && customCategory.trim()) {
//                 setCategory(customCategory.trim());
//                 setShowCustomCategoryInput(false);
//               }
//             }}
//             style={{ marginTop: "25px", minWidth: "200px", minHeight: "50px" }}
//           />
//         )}

//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "16px",
//             translate: "0px 8px",
//           }}
//         >
//           <FilePicker
//             multiple
//             width={150}
//             className="custom-file-picker"
//             height={40}
//             placeholder="Select Your File"
//             onChange={handleFileChange}
//           />
//         </div>
//         <Button
//           variant="contained"
//           onClick={handleFileUpload}
//           style={{
//             backgroundColor: "#0d5eff",
//             width: "120px",
//             height: "43px",
//             translate: "140px 8px",
//             color: "white",
//           }}
//           endIcon=<GrDocumentUpload style={{ fontSize: '16px' }} />
//         >
//           Upload
//         </Button>

//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleClose}
//           style={{ marginLeft: "120px", translate: "0px -25px" }}
//         >
//           {(category === "Proposal") || showCustomCategoryInput ? (
//             <>
//               <MenuItem onClick={() => handleFileUpload()}>
//                 Upload Only
//               </MenuItem>
//             </>
//           ) : (
//             <>
//               <MenuItem onClick={() => handleFileUpload()}>
//                 SoW Review
//               </MenuItem>
//             </>
//           )}
//         </Menu>
//       </div>

//       {error && <p style={{ color: "red" }}>{error}</p>}

//       {loading && !error && (
//         <div
//           style={{
//             color: " #074173",
//             textAlign: "center",
//             fontSize: "3.5vh",
//             zIndex: "0",
//           }}
//         >
//           <div style={{ position: "relative", translate: "90vh" }}>
//             {" "}
//             <RingLoader color="rgb(1, 96, 90)" size={25} />
//           </div>
//           <div
//             style={{ display: "flex", alignItems: "center", translate: "75vh" }}
//           >
//             <p style={{ color: "#074173" }}>
//               Please Wait, it takes time&nbsp;{" "}
//             </p>
//             <ScaleLoader color=" #074173" height={15} width={2} margin={2} />
//           </div>
//         </div>
//       )}
//       <div style={{ translate: "780px -65px" }}></div>

//       <TableContainer
//         component={Paper}
//         style={{
//           marginTop: "16px",
//           maxHeight: "400px",
//           overflowY: "auto",
//           overflowX: isSmallScreen ? "auto" : "hidden",
//           scrollbarWidth: "thin",
//         }}
//       >
//         <Table>
//           <TableHead style={{ height: "70px" }}>
//             <TableRow
//               style={{
//                 position: "sticky",
//                 top: 0,
//                 zIndex: 1,
//                 backgroundColor: "rgb(165, 164, 164)",
//               }}
//             >
//               <TableCell
//                 style={{
//                   translate: "50px",
//                   fontSize: "15px",
//                   padding: "10px 16px",
//                   // width:'300px'
//                   position: "sticky",
//                   top: 0,
//                   zIndex: 1,
//                   fontWeight: "bold",
//                 }}
//               >
//                 Document Category
//               </TableCell>
//               <TableCell
//                 style={{
//                   translate: filesList.length === 0 ? "-80px" : "270px",
//                   fontSize: "15px",
//                   padding: "10px 16px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 File
//               </TableCell>
//               <TableCell
//                 style={{
//                   translate: "45px",
//                   fontSize: "15px",
//                   padding: "10px 16px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Actions
//               </TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {filesList &&
//               filesList
//                 .slice()
//                 .reverse()
//                 .map((file, index) => (
//                   <TableRow
//                     key={file._id}
//                     style={{
//                       backgroundColor: index % 2 === 0 ? "white" : "#ddd",
//                       height: "30px",
//                     }}
//                   >
//                     <TableCell
//                       style={{
//                         translate: "50px",
//                         padding: "10px 16px",
//                         fontSize: "15px",
//                         color: "#3c3c3c",
//                       }}
//                     >
//                       {file.category}
//                     </TableCell>
//                     <TableCell style={{ padding: "2px 10px" }}>
//                       {file.url &&
//                         file.url.map((url, urlIndex) => (
//                           <div key={urlIndex}>
//                             <Tooltip
//                               title={getFileName(url) || ""}
//                               placement="top"
//                               classes={{ tooltip: css.label }}
//                             >
//                               <IconButton
//                                 style={{ backgroundColor: "transparent" }}
//                                 onClick={() => window.open(url, "_blank")}
//                               >
//                                 <span
//                                   style={{
//                                     fontSize: "17px",
//                                     translate: "120px 3px",
//                                   }}
//                                 >
//                                   {getFileIcon(getFileType(url))}
//                                 </span>
//                                 <span
//                                   style={{
//                                     fontSize: "15px",
//                                     translate: "120px",
//                                     fontFamily: "system-ui",
//                                   }}
//                                 >
//                                   {getFileName(url)?.slice(0, 70)}
//                                 </span>
//                               </IconButton>
//                             </Tooltip>
//                           </div>
//                         ))}
//                     </TableCell>
//                     <TableCell
//                       style={{ padding: "4px 16px", translate: "25px" }}
//                     >
//                       <IconButton
//                         onClick={(event) => handleDeleteClick(file._id, event)}
//                       >
//                         <RiDeleteBin6Line color="rgb(0, 26, 110)" />
//                       </IconButton>

//                       <Dialog
//                         open={open}
//                         onClose={close}
//                         slotProps={{
//                           backdrop: {
//                             style: {
//                               backgroundColor: "transparent",
//                             },
//                           },
//                           paper: {
//                             style: {
//                               width: "253px",
//                               height: "120px",
//                               position: "absolute",
//                               top: dialogPosition.top - 40,
//                               left: dialogPosition.left - 300,
//                               borderRadius: "4px",
//                               overflow: "hidden",
//                               boxShadow: "none",
//                               border: "1px solid grey",
//                             },
//                           },
//                         }}
//                       >
//                         <DialogTitle
//                           style={{
//                             fontSize: "1rem",
//                             translate: "-17px",
//                           }}
//                         >
//                           Confirm Deletion
//                         </DialogTitle>
//                         <DialogContent
//                           style={{
//                             overflow: "hidden",
//                             translate: "0px -7px",
//                           }}
//                         >
//                           <DialogContentText
//                             style={{
//                               whiteSpace: "nowrap",
//                               fontSize: "0.8rem",
//                               translate: "-17px",
//                             }}
//                           >
//                             Are you sure you want to delete this file?
//                           </DialogContentText>
//                         </DialogContent>
//                         <DialogActions>
//                           <Button
//                             onClick={close}
//                             style={{
//                               translate: "20px -14px",
//                               color: "#074173",
//                               backgroundColor: "transparent",
//                             }}
//                           >
//                             No
//                           </Button>
//                           <Button
//                             onClick={handleDel}
//                             style={{
//                               translate: "0px -14px",
//                               color: "#074173",
//                               backgroundColor: "transparent",
//                             }}
//                           >
//                             Yes
//                           </Button>
//                         </DialogActions>
//                       </Dialog>
//                       <Tooltip
//                         title="Download functionality will be implemented soon"
//                         placement="top"
//                         classes={{ tooltip: css.label }}
//                       >
//                         <span>
//                           <IconButton
//                             onClick={() => handleDownload(file._id)}
//                           >
//                             <RiDownload2Line color="rgb(0, 26, 110)" />
//                           </IconButton>
//                         </span>
//                       </Tooltip>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//     </div>
//   );
// };
// export default FileUpload;

import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  IconButton,
  Input,
} from "@material-ui/core";
import {
  Delete as DeleteIcon,
  CloudUpload as CloudUploadIcon,
  GetApp as GetAppIcon,
} from "@material-ui/icons";
import { FilePicker, Text } from "evergreen-ui";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core/styles";
import "./attachment.scss";
import axiosInstance from "../../../../../httpInterceptor";
import { useParams } from "react-router-dom";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { CiFileOn } from "react-icons/ci";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit, faDownload } from "@fortawesome/free-solid-svg-icons";
import RingLoader from "react-spinners/RingLoader";
import HashLoader from "react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { RiDeleteBin6Line, RiDownload2Line } from "react-icons/ri";
import {
  FaFilePdf,
  FaFileWord,
  FaFileAlt,
  FaFile,
  FaFilePowerpoint,
} from "react-icons/fa";
import { GrDocumentUpload } from "react-icons/gr";
import axios from "axios";
import Menu from "@mui/material/Menu";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import { MdEmail } from "react-icons/md";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import {
  AssessmentData,
  ProjectDataType,
  Qnadetails,
} from "../../../../../models/interfaces/interfaces";

import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  SelectChangeEvent,
  TooltipProps,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { saveAs } from "file-saver";
pdfjs.GlobalWorkerOptions.workerSrc = "/js/pdf.worker.min copy.mjs";
interface FileUploadProps {
  projectid?: string;
  setName?: string;
  emails: string[];
}
interface UploadedFile {
  _id: string;
  category: string;
  url: string[];
  type: string;
}
interface FileRecord {
  projectid: string;
  set_name: string;
  // Some responses use `files` and some use `file` (note singular).
  // Accept either shape to be tolerant of backend differences.
  files?: UploadedFile[];
  file?: UploadedFile[];
}

const customeToolpit = makeStyles({
  tooltip: {
    backgroundColor: "white",
    color: "blue",
  },
});

const useStyles = makeStyles((theme: any) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  uploadButton: {
    margin: theme.spacing(1),
  },
  table: {
    marginTop: theme.spacing(2),
  },
  errorMessage: {
    color: "red",
  },
  loadingMessage: {
    color: "orange",
    textAlign: "center",
  },
}));

const FileUpload: React.FC<FileUploadProps> = ({
  projectid,
  setName,
  emails,
}) => {
  const [files, setFiles] = useState<File[]>([]);
  const [filesList, setFilesList] = useState<UploadedFile[]>([]);
  const [category, setCategory] = useState("");
  const [customCategory, setCustomCategory] = useState("");
  const [showCustomCategoryInput, setShowCustomCategoryInput] = useState(false);
  const [cloudFrontUrls, setCloudFrontUrls] = useState<string[]>([]);
  const [error, setError] = useState("");
  const [previewUrls, setPreviewUrls] = useState<string[]>([]);
  const [emailAdresses, setEmailAddress] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showFullFileName, setShowFullFileName] = useState<{
    [key: number]: boolean;
  }>({});
  const [loading, setLoading] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<string | null>(null);

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [mails, setEmails] = useState<string[]>([]);
  const [showEmailField, setShowEmailField] = useState(false);
  const [isSubmitButton, setIsSubmitButton] = useState(false);
  const { proj_id, set_name } = useParams<{
    proj_id: string;
    set_name: string;
  }>();
  const [dialogPosition, setDialogPosition] = useState({ top: 0, left: 0 });
  const [assessmentData, setAssessmentData] = useState<AssessmentData>({
    projectid: proj_id || "",
    set_name: set_name || "",
    emailIds: JSON.parse(localStorage.getItem("emailIds") || "[]"),
    assessmentdetails: [
      {
        assessmentdate: `${new Date().toISOString().split("T")[0]}`,
        projectstatus: "",
        reasonforchange: "",
        qnadetails: [],
        created_by: `${sessionStorage.getItem("PBT_FIRSTNAME") || ""} ${sessionStorage.getItem("PBT_LASTNAME") || ""
          }`,
        modified_by: "",
      },
    ],
  });

  const isSmallScreen = useMediaQuery('(max-width:1200px)');

  useEffect(() => {
    fetchFiles();
  }, []);

  useEffect(() => {
    document.body.setAttribute("data-loading", loading ? "true" : "false");

    return () => {
      document.body.removeAttribute("data-loading");
    };
  }, [loading]);

  const fetchFiles = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/files/${projectid}/${setName}`
      );
      const fileRecords: FileRecord[] = response.data || [];
      const allFiles = fileRecords.flatMap((record) => {
        if (Array.isArray(record.files)) return record.files;
        if (Array.isArray(record.file)) return record.file;
        return [] as UploadedFile[];
      });
      setFilesList(allFiles);
      console.log(allFiles);
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };
  console.log(filesList[0]);

  const allowedFileTypes = [
    "application/pdf",
    "text/plain",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ];

  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const selectedFiles = Array.from(e.target.files || []);
  //   const validFiles = selectedFiles.filter((file: File) =>
  //     allowedFileTypes.includes(file.type)
  //   );
  //   if (validFiles.length !== selectedFiles.length) {
  //     setError(
  //       "Some files have invalid types. Only PDF, TXT, DOC, DOCX,PPTX files are allowed."
  //     );
  //   } else {
  //     setError("");
  //   }
  //   setFiles(validFiles as File[]);
  // };

  const handleFileChange = (fileList: FileList) => {
    const selectedFiles = Array.from(fileList);
    const validFiles = selectedFiles.filter((file) =>
      allowedFileTypes.includes(file.type)
    );

    if (validFiles.length !== selectedFiles.length) {
      setError(
        "Some files have invalid types. Only PDF, TXT, DOC, DOCX, PPTX files are allowed."
      );
    } else {
      setError("");
    }

    setFiles(validFiles);
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailAddress(e.target.value);
  };

  const handleCategoryChange = (event: any) => {
    const selected = event.target.value;

    if (selected === "Others") {
      setShowCustomCategoryInput(true);
      setCategory(""); // Clear category until custom input is submitted
    } else {
      setShowCustomCategoryInput(false);
      setCategory(selected);
    }
  };

  const handleCustomCategoryChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCustomCategory(e.target.value);
  };

  const handleCustomCategorySubmit = (
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    setCategory(customCategory);
  };
  const handleFileUpload = async () => {
    let finalCategory = category;

    if (showCustomCategoryInput && customCategory.trim()) {
      finalCategory = customCategory.trim();
    }

    if (files.length === 0) {
      setError("No files selected.");
      return;
    }
    if (!projectid) {
      setError("Project ID is required.");
      return;
    }
    if (!setName) {
      setError("Set name is required.");
      return;
    }
    if (!finalCategory) {
      setError("Category is required.");
      return;
    }

    // Use finalCategory instead of category in formData

    console.log(category);
    let uploadedUrls: string[] = [];
    const previewUrls: string[] = [];
    setLoading(true);
    try {
      for (const file of files) {
        const presignRes = await axiosInstance.post(`${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/generate-presigned-url`, {
          fileName: file.name,
          fileType: file.type,
        });
        const uploadUrl = presignRes.data.url;
        console.log("Presigned URL:", uploadUrl);
        const cloudFrontUrl = uploadUrl.replace(
          /^https:\/\/[^/]+\.s3\.amazonaws\.com\//,
          `${process.env.REACT_APP_CLOUDFRONT_BASE_URL}/`
        );
        console.log("CloudFront URL:", cloudFrontUrl);

        await fetch(uploadUrl, {
          method: "PUT",
          headers: {
            "Content-Type": file.type,
          },
          body: file,
        });

        const processRes = await axiosInstance.post(`${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/process-uploaded-file`, {
          fileName: file.name,
          projectid,
          set_name: setName,
          category: finalCategory,
          mimetype: file.type,
        });
        console.log("Process response:", processRes.data);
        toast.success("File successfully uploaded and processed");
        uploadedUrls.push(cloudFrontUrl);
        previewUrls.push(URL.createObjectURL(file));
      }
      setCloudFrontUrls(uploadedUrls);
      setPreviewUrls(previewUrls);
      setDropdownOpen(false);
      fetchFiles();
    } catch (error: any) {
      console.error("Error uploading file:", error);

      if (error.response && error.response.data) {
        console.log(error.response.data);
        setError(error.response.data);
        console.log(error);
      } else {
        setError("Error uploading file.");
      }
    } finally {
      setLoading(false);
    }
  };
  //       const response = await axiosInstance.post(
  //         `${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/upload/${projectid}/${setName}`,
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );
  //       if (response.data) {
  //         toast.success("File successfully uploaded");
  //         // window.location.reload();
  //         console.log(formData);
  //         console.log(response);
  //         uploadedUrls.push(response.data.cloudFrontUrls);
  //         previewUrls.push(URL.createObjectURL(file));
  //         console.log(uploadedUrls);
  //       }
  //     }
  //     if (withEmail) {
  //       const emailPayload = {
  //         projectid,
  //         setName,
  //         toEmail: emails,
  //         emailType: "file",
  //         files: uploadedUrls,
  //       };
  //       const res = await axiosInstance.post(
  //         `${process.env.REACT_APP_EMAIL_SERVICE_BASE_URL}/email`,
  //         emailPayload,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       if (res.data) {
  //         toast.success(
  //           "Email sent successfully. Thank you, check your email."
  //         );
  //       }
  //     }
  //     window.location.reload();
  //     setLoading(false);
  //   } catch (error: any) {
  //     console.error("Error uploading file:", error);

  //     if (error.response && error.response.data) {
  //       console.log(error.response.data);
  //       setError(error.response.data);
  //       console.log(error);
  //     } else {
  //       setError("Error uploading file.");
  //     }
  //   }

  //   setCloudFrontUrls(uploadedUrls);
  //   setPreviewUrls(previewUrls);
  //   setDropdownOpen(false);
  //   fetchFiles();
  //   // setError("");
  //   console.log("Files uploaded successfully:", uploadedUrls);
  //   console.log(setPreviewUrls);
  // };

  const handleButtonClick = async () => {
    setShowEmailField(true);
  };
  const handleDelete = async (_id: string) => {
    await axiosInstance.delete(
      `${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/delete/${_id}`
    );
    toast.success("File deleted successfully");
    fetchFiles();
  };

  const handleDownload = async (_id: string) => {
    console.log("Downloading file with id:", _id);
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/files/download/${_id}`
      );
      const downloadUrl = response.data.downloadUrl; // Assuming the URL is returned in the response data
      console.log("Download URL:", downloadUrl);
      // const link = document.createElement("a");
      // link.href= downloadUrl;
      // link.download = getFileName(downloadUrl) || "file.pdf"; // Default filename if not provided
      // document.body.appendChild(link);
      // link.click();

      // Fetch the file as a blob
      const fileResponse = await axios.get(downloadUrl, {
        responseType: 'blob',
      });

      // // Extract filename from URL or use default
      // const fileName = getFileName(downloadUrl) || "downloaded_file.pdf";

      // // Save the file locally
      // saveAs(fileResponse.data, fileName);

      const fileName = decodeURIComponent(downloadUrl.split("/").pop()?.split("?")[0] || "downloaded_file");
      const fileExtension = fileName.split(".").pop()?.toLowerCase();


      // // document.body.removeChild(link);
      const blobUrl = window.URL.createObjectURL(new Blob([fileResponse.data]));

      // You can customize the extension here
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error("Failed to download file");
    }
    // // Extract filename from the response headers
    // const contentDisposition = response.headers["content-disposition"];
    // let filename = "file.pdf"; // Default filename
    // if (contentDisposition) {
    //   const filenameMatch = contentDisposition.match(/filename="(.+)"/);
    //   if (filenameMatch.length === 2) {
    //     filename = filenameMatch[1];
    //   }
    // }

    // const url = window.URL.createObjectURL(new Blob([response.data]));
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", filename);
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const getFileName = (url: string) => {
    return url.split("/").pop();
  };
  const toggleFullFileName = (index: number) => {
    setShowFullFileName((prevState) => ({
      [index]: !prevState[index],
    }));
  };

  const getFileIcon = (fileType: any): JSX.Element => {
    switch (fileType) {
      case "pdf":
        return <FaFilePdf style={{ color: "red" }} />;
      case "docx":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return <FaFileWord style={{ color: "blue" }} />;
      case "pptx":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        return <FaFilePowerpoint style={{ color: "orange" }} />;
      case "txt":
        return <FaFileAlt style={{ color: "green" }} />;
      default:
        return <FaFile style={{ color: "gray" }} />;
    }
  };

  const getFileType = (url: string): string => {
    const fileName = url.split("/").pop();
    if (fileName) {
      const fileType = fileName
        .split(".")
        .pop()
        ?.replace(/[^a-zA-Z].*$/, "");
      return fileType || "";
    }
    return "";
  };
  const CustomTextField = styled(TextField)({
    "& .MuiInput-underline:before": {
      borderBottomColor: "initial",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: " #074173",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: " #074173",
    },
  });
  const useStyles = makeStyles((theme) => ({
    modalBox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      background: "#ddd",

      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      outline: "none",
      height: "40vh",
      borderRadius: "4px",
    },
    emailField: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
    },
    buttonEmail: {
      display: "flex",
      justifyContent: "space-between",
    },
    emailTag: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
    },
    label: {
      color: " #0d5eff",
      background: "white",
      fontSize: "0.7rem",
      border: "0.3px solid #ddd",
    },
  }));

  const handleDeleteClick = (
    itemId: any,
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setDialogPosition({
      top: rect.top + window.scrollY,
      left: rect.left + window.scrollX,
    });

    setItemToDelete(itemId);
    setOpen(true);
  };

  const handleDel = () => {
    if (itemToDelete !== null) {
      handleDelete(itemToDelete);
      setOpen(false);
    }
  };

  const handleConfirmDelete = (_id: string) => {
    handleDelete(_id);
    setOpen(false);
  };

  const close = () => {
    setOpen(false);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSaveEmails = async () => {
    const projectKey = `${assessmentData.projectid}_${assessmentData.set_name}`;
    const storedData = JSON.parse(localStorage.getItem("emailData") || "{}");
    const existingEmailIds = storedData[projectKey] || [];
    // Merge and deduplicate email IDs
    const emailSet = new Set([...existingEmailIds, ...emails]);
    const updatedEmailIds = Array.from(emailSet);
    // Store the updated email IDs in localStorage
    storedData[projectKey] = updatedEmailIds;
    localStorage.setItem("emailData", JSON.stringify(storedData));
    alert("Email IDs saved successfully!");
    setEmails(updatedEmailIds);
    setShowEmailField(false);
    // Send the combined email IDs to the backend
    if (assessmentData.projectid && assessmentData.set_name) {
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_UPLOAD_SERVICE_BASE_URL}/create-projectassesment`,
          {
            projectid: assessmentData.projectid,
            set_name: assessmentData.set_name,
            emailIds: updatedEmailIds,
          }
        );
        console.log("Response from API:", response);
        if (response.data) {
          toast.success("Email IDs updated successfully");
        }
      } catch (error) {
        console.error("Error updating email IDs:", error);
        toast.error("Failed to update email IDs");
      }
    }
  };
  const handleCloseModal = () => {
    setShowEmailField(false);
  };

  const css = useStyles();

  return (
    <div style={{ padding: "24px" }}>
      <div
        style={{
          backgroundColor: "rgb(165, 164, 164)",
          padding: "1.3rem",
          borderRadius: "3px",
          translate: "-25px -25px",
          width: "101%",
        }}
      ></div>
      <Typography style={{ color: "#888888", fontFamily: "System-ui" }}>
        Only documents in TXT, PDF, PPTX, or DOCX formats are permitted
      </Typography>
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <FormControl style={{ margin: "8px", minWidth: "200px" }}>
          <InputLabel style={{ translate: "-9px" }}>Document Type</InputLabel>
          <Select
            style={{ translate: "-9px 4px" }}
            onChange={(event) => handleCategoryChange(event)}
            inputProps={{
              classes: {
                underline: {
                  "&:before": {
                    borderBottomColor: "#074173",
                  },
                  "&:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "#074173", // Color on hover
                  },
                  "&:after": {
                    borderBottomColor: "#074173", // Default color when focused
                  },
                },
              },
            }}
          >
            <MenuItem value="">Category Type</MenuItem>
            <MenuItem value="Proposal">Proposal</MenuItem>
            <MenuItem value="SoW - Development1">SoW - Development1</MenuItem>
            <MenuItem value="SoW - Development2">SoW - Development2</MenuItem>
            <MenuItem value="SoW - Support">SoW - Support</MenuItem>
            <MenuItem value="SoW Details Extraction">
              SoW Details Extraction
            </MenuItem>
            <MenuItem value="Others">Others</MenuItem>
          </Select>
        </FormControl>

        {showCustomCategoryInput && (
          <TextField
            label="Category Type"
            variant="outlined"
            size="small"
            value={customCategory}
            onChange={(e) => setCustomCategory(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && customCategory.trim()) {
                setCategory(customCategory.trim());
                setShowCustomCategoryInput(false);
              }
            }}
            style={{ marginTop: "25px", minWidth: "200px", minHeight: "50px" }}
          />
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            translate: "0px 8px",
          }}
        >
          <FilePicker
            multiple
            width={150}
            className="custom-file-picker"
            height={40}
            placeholder="Select Your File"
            onChange={handleFileChange}
          />
        </div>
        <Button
          variant="contained"
          onClick={handleFileUpload}
          style={{
            background: "linear-gradient(135deg, #0d5eff 0%, #073fb1 100%)",
            width: "120px",
            height: "43px",
            translate: "140px 8px",
            color: "white",
          }}
          endIcon=<GrDocumentUpload style={{ fontSize: '16px' }} />
        >
          Upload
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          style={{ marginLeft: "120px", translate: "0px -25px" }}
        >
          {(category === "Proposal") || showCustomCategoryInput ? (
            <>
              <MenuItem onClick={() => handleFileUpload()}>
                Upload Only
              </MenuItem>
            </>
          ) : (
            <>
              <MenuItem onClick={() => handleFileUpload()}>
                SoW Review
              </MenuItem>
            </>
          )}
        </Menu>
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {loading && !error && (
        <div
          style={{
            color: " #FF5E4F",
            textAlign: "center",
            fontSize: "3.5vh",
            zIndex: "0",
          }}
        >
          <div style={{ position: "relative", translate: "90vh" }}>
            {" "}
            <RingLoader color="#FF5E4F" size={25} />
          </div>
          <div
            style={{ display: "flex", alignItems: "center", translate: "75vh" }}
          >
            <p style={{ color: "#FF5E4F" }}>
              Please Wait, it takes time&nbsp;{" "}
            </p>
            <ScaleLoader color=" #fc4d3dff" height={15} width={2} margin={2} />
          </div>
        </div>
      )}
      <div style={{ translate: "780px -65px" }}></div>

      <TableContainer
        component={Paper}
        style={{
          marginTop: "16px",
          maxHeight: "400px",
          overflowY: "auto",
          overflowX: isSmallScreen ? "auto" : "hidden",
          scrollbarWidth: "thin",
        }}
      >
        <Table>
          <TableHead style={{ height: "70px" }}>
            <TableRow
              style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "#8E8E8E",
              }}
            >
              <TableCell
                style={{
                  translate: "50px",
                  fontSize: "15px",
                  padding: "10px 16px",
                  // width:'300px'
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  fontWeight: "bold",
                }}
              >
                Document Category
              </TableCell>
              <TableCell
                style={{
                  translate: filesList.length === 0 ? "-80px" : "270px",
                  fontSize: "15px",
                  padding: "10px 16px",
                  fontWeight: "bold",
                }}
              >
                File
              </TableCell>
              <TableCell
                style={{
                  translate: "45px",
                  fontSize: "15px",
                  padding: "10px 16px",
                  fontWeight: "bold",
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filesList &&
              filesList
                .slice()
                .reverse()
                .filter((file) => file != null)
                .map((file, index) => (
                  <TableRow
                    key={file?._id || index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "white" : "#ddd",
                      height: "30px",
                    }}
                  >
                    <TableCell
                      style={{
                        translate: "50px",
                        padding: "10px 16px",
                        fontSize: "15px",
                        color: "#3c3c3c",
                      }}
                    >
                      {file?.category || ""}
                    </TableCell>
                    <TableCell style={{ padding: "2px 10px" }}>
                      {file?.url &&
                        file.url.map((url, urlIndex) => (
                          <div key={urlIndex}>
                            <Tooltip
                              title={getFileName(url) || ""}
                              placement="top"
                              classes={{ tooltip: css.label }}
                            >
                              <IconButton
                                style={{ backgroundColor: "transparent" }}
                                onClick={() => window.open(url, "_blank")}
                              >
                                <span
                                  style={{
                                    fontSize: "17px",
                                    translate: "120px 3px",
                                  }}
                                >
                                  {getFileIcon(getFileType(url))}
                                </span>
                                <span
                                  style={{
                                    fontSize: "15px",
                                    translate: "120px",
                                    fontFamily: "system-ui",
                                  }}
                                >
                                  {getFileName(url)?.slice(0, 70)}
                                </span>
                              </IconButton>
                            </Tooltip>
                          </div>
                        ))}
                    </TableCell>
                    <TableCell
                      style={{ padding: "4px 16px", translate: "25px" }}
                    >
                      <IconButton
                        onClick={(event) => handleDeleteClick(file._id, event)}
                      >
                        <RiDeleteBin6Line color="#FF5E4F" />
                      </IconButton>

                      <Dialog
                        open={open}
                        onClose={close}
                        slotProps={{
                          backdrop: {
                            style: {
                              backgroundColor: "transparent",
                            },
                          },
                          paper: {
                            style: {
                              width: "253px",
                              height: "120px",
                              position: "absolute",
                              top: dialogPosition.top - 40,
                              left: dialogPosition.left - 300,
                              borderRadius: "4px",
                              overflow: "hidden",
                              boxShadow: "none",
                              border: "1px solid grey",
                            },
                          },
                        }}
                      >
                        <DialogTitle
                          style={{
                            fontSize: "1rem",
                            translate: "-17px",
                          }}
                        >
                          Confirm Deletion
                        </DialogTitle>
                        <DialogContent
                          style={{
                            overflow: "hidden",
                            translate: "0px -7px",
                          }}
                        >
                          <DialogContentText
                            style={{
                              whiteSpace: "nowrap",
                              fontSize: "0.8rem",
                              translate: "-17px",
                            }}
                          >
                            Are you sure you want to delete this file?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={close}
                            style={{
                              translate: "20px -14px",
                              color: "#FF5E4F",
                              backgroundColor: "transparent",
                            }}
                          >
                            No
                          </Button>
                          <Button
                            onClick={handleDel}
                            style={{
                              translate: "0px -14px",
                              color: "#FF5E4F",
                              backgroundColor: "transparent",
                            }}
                          >
                            Yes
                          </Button>
                        </DialogActions>
                      </Dialog>
                      <Tooltip
                        title="Download functionality will be implemented soon"
                        placement="top"
                        classes={{ tooltip: css.label }}
                      >
                        <span>
                          <IconButton
                            onClick={() => handleDownload(file._id)}
                          >
                            <RiDownload2Line color="#FF5E4F" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>

    </div>
  );
};
export default FileUpload;
